<template>
  <div class="home">
    <UnitList v-show="listView" @newUnit="onClickNewFromList" @editUnit="onClickEditFromList" @showUnit="onClickShowFromList" :scroll="corY" ref="refreshList"/>
    <UnitForm v-show="formView" :unit="unit" @backClicked="onBackChild"/>
    <UnitShow v-show="showView" :unit="unit" @backClicked="onBackChild"/>
  </div>
</template>

<script>
import UnitList from '@/components/unit/UnitList.vue'
import UnitForm from '@/components/unit/UnitForm.vue'
import UnitShow from '@/components/unit/UnitShow.vue'
import { mapState } from 'vuex'

export default {
  name: 'Unit',
  components: {
    UnitList,
    UnitForm,
    UnitShow
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      showView: false,
      unit: {
        id: null,
        unit_no: null,
        unit_date: null,
        type_id: null,
        type: null,
        name: null,
        alias: null,
        schedule_date: null,
        storage_date: null,
        start_date: null,
        finish_date: null,
        sale_no: null,
        notes: null,
        company_no: null,
        asset_no: null,
        asset: {
          id: null,
          type_id: null,
          asset_no: null,
          asset_name: null,
          date_buy: null,
          date_reduce: null,
          date_process: null,
          asset_age: null,
          asset_age_remaining: null,
          asset_amount: '0',
          asset_amount_reduce: '0',
          asset_fix_amount: '0',
          outlet_code: null,
          status: null,
          serial_number: null,
          internal_number: null,
          condition: null,
          active: false,
          picture: null
        },
        customer_no: null,
        customer: {
          id: null,
          customer_no: null,
          name: null,
          email: null,
          phone: null
        },
        check_person: null,
        check_person_name: null,
        created_by: null,
        created_by_name: null,
        status: null,
        lock: null,
        product_no: null,
        fuel_bar: null,
        fuel_total: null,
        fuel_uom: null,
        fuels: [{
          id: null,
          unit_no: null,
          unit_date: null,
          queue: null,
          bar: '0',
          qty: '0',
          uom_id: null,
          status: null,
          warehouse_no: null,
          company_no: null
        }]
      }
    }
  },
  computed: {
    ...mapState({
      authUser: state => state.users.authUser
    })
  },
  methods: {
    onClickShowFromList (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      console.log(value)
      this.listView = false
      this.formView = false
      this.showView = true
      this.unit = value
    },
    onClickEditFromList: function (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      console.log(value)
      this.listView = false
      this.formView = true
      this.showView = false
      this.unit = value
      var payload = {
        status: 'order'
      }
      this.$store.dispatch('getProductListSelect', payload)
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.showView = false
      this.unit = {
        id: null,
        unit_no: null,
        unit_date: new Date().toISOString(),
        type_id: 'customer',
        type: null,
        name: null,
        alias: null,
        schedule_date: null,
        storage_date: null,
        start_date: null,
        finish_date: null,
        sale_no: null,
        notes: null,
        company_no: this.authUser.company_no,
        asset_no: null,
        asset: {
          id: null,
          type_id: null,
          asset_no: null,
          asset_name: null,
          date_buy: null,
          date_reduce: null,
          date_process: null,
          asset_age: null,
          asset_age_remaining: null,
          asset_amount: '0',
          asset_amount_reduce: '0',
          asset_fix_amount: '0',
          outlet_code: null,
          status: null,
          serial_number: null,
          internal_number: null,
          condition: null,
          active: false,
          picture: null
        },
        customer_no: null,
        customer: {
          id: null,
          customer_no: null,
          name: null,
          email: null,
          phone: null
        },
        check_person: null,
        check_person_name: null,
        created_by: this.authUser.username,
        created_by_name: null,
        product_no: null,
        fuel_bar: null,
        fuel_total: null,
        fuel_uom: null,
        fuels: []
      }
      var payload = {
        status: 'order'
      }
      this.$store.dispatch('getProductListSelect', payload)
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.showView = false
      this.unit = {
        id: null,
        unit_no: null,
        unit_date: null,
        type_id: null,
        type: null,
        name: null,
        alias: null,
        schedule_date: null,
        storage_date: null,
        start_date: null,
        finish_date: null,
        sale_no: null,
        notes: null,
        company_no: null,
        asset_no: null,
        asset: {
          id: null,
          type_id: null,
          asset_no: null,
          asset_name: null,
          date_buy: null,
          date_reduce: null,
          date_process: null,
          asset_age: null,
          asset_age_remaining: null,
          asset_amount: '0',
          asset_amount_reduce: '0',
          asset_fix_amount: '0',
          outlet_code: null,
          status: null,
          serial_number: null,
          internal_number: null,
          condition: null,
          active: false,
          picture: null
        },
        customer_no: null,
        customer: {
          id: null,
          customer_no: null,
          name: null,
          email: null,
          phone: null
        },
        check_person: null,
        check_person_name: null,
        created_by: null,
        created_by_name: null,
        product_no: null,
        fuel_bar: null,
        fuel_total: null,
        fuel_uom: null,
        fuels: [{
          id: null,
          unit_no: null,
          unit_date: null,
          queue: null,
          bar: '0',
          qty: '0',
          uom_id: null,
          status: null,
          warehouse_no: null,
          company_no: null
        }]
      }
      await this.$refs.refreshList.refreshList()
      await window.scrollTo(this.corX, this.corY)
      console.log('window.scrollTo:' + this.corY)
    }
  },
  mounted () {
    this.$store.dispatch('getUnitTypeList')
    this.$store.dispatch('getCompanyList')
    this.$store.dispatch('getUomList')
    this.$store.dispatch('getRowTable')
  }
}
</script>
